<div class="table-container" [class.loading]="config().loading">
  <!-- Loading overlay -->
  @if (config().loading) {
    <div class="loading-overlay">
      <mat-spinner diameter="50"></mat-spinner>
    </div>
  }

  <!-- Horizontally scrollable table wrapper -->
  <div class="table-scroll-wrapper">
    <!-- Table -->
    <table
      mat-table
      [dataSource]="dataSource()"
      matSort
      [matSortActive]="sortProp()"
      [matSortDirection]="sortDir()"
      (matSortChange)="onSortChange($event)"
      class="data-table"
      [class.row-clickable]="config().rowClickable && !displayedColumns().includes('actions')"
    >
      <!-- Actions Column (Always First) -->
      @if (displayedColumns().includes('actions')) {
        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef class="actions-header">Actions</th>
          <td mat-cell *matCellDef="let row" class="actions-cell">
            <div class="actions-buttons">
              <!-- View/details action: a real <a routerLink>, not a (click) handler —
                   only a genuine href lets the browser offer "Open link in new tab" /
                   ctrl-click / middle-click. Always first. -->
              @if (getDetailsRoute(row); as detailsRoute) {
                <a
                  mat-icon-button
                  color="primary"
                  [routerLink]="detailsRoute"
                  [matTooltip]="'View Details'"
                  (click)="$event.stopPropagation()"
                >
                  <mat-icon>visibility</mat-icon>
                </a>
              }

              <!-- Custom actions template -->
              @if (rowActionsTemplate()) {
                <ng-container
                  *ngTemplateOutlet="rowActionsTemplate()!; context: { $implicit: row }"
                ></ng-container>
              }
              
              <!-- Default actions -->
              @for (action of actions(); track action.label) {
                @if (shouldShowAction(action, row)) {
                  <button
                    mat-icon-button
                    [color]="action.color || 'primary'"
                    [disabled]="isActionDisabled(action, row)"
                    [matTooltip]="action.label"
                    (click)="onActionClick(action, row, $event)"
                  >
                    <mat-icon>{{ action.icon }}</mat-icon>
                  </button>
                }
              }
            </div>
          </td>
        </ng-container>
      }

      <!-- Data Columns -->
      @for (column of config().columns; track column.key) {
        <ng-container [matColumnDef]="column.key">
          <th
            mat-header-cell
            *matHeaderCellDef
            [mat-sort-header]="column.sortable !== false ? column.key : ''"
            [disabled]="column.sortable === false"
            [style.min-width]="column.minWidth"
            [style.max-width]="column.maxWidth || column.width"
          >
            {{ column.header }}
          </th>
          <td
            mat-cell
            *matCellDef="let row"
            [class]="getCellClass(row, column)"
            [style.min-width]="column.minWidth"
            [style.max-width]="column.maxWidth || column.width"
          >
            @if (column.template) {
              <ng-container
                *ngTemplateOutlet="column.template; context: { $implicit: row, value: getCellValue(row, column) }"
              ></ng-container>
            } @else if (column.type === 'image') {
              @if (getCellValue(row, column)) {
                <img fhImageUrl [originalUrl]="getCellValue(row, column)" [alt]="column.header" class="table-image" />
              }
            } @else {
              {{ getCellValue(row, column) }}
            }
          </td>
        </ng-container>
      }

      <!-- Header Row -->
      <tr
        mat-header-row
        *matHeaderRowDef="displayedColumns(); sticky: config().stickyHeader"
      ></tr>

      <!-- Data Rows -->
      <tr
        mat-row
        *matRowDef="let row; columns: displayedColumns()"
        (click)="onRowClick(row, $event)"
        [class.highlighted]="isRowHighlighted(row)"
        [class.clickable]="config().rowClickable && !displayedColumns().includes('actions')"
      ></tr>
    </table>
  </div>

  <!-- Empty State -->
  @if (!config().loading && dataSource().data.length === 0) {
    <div class="empty-state">
      <mat-icon>inbox</mat-icon>
      <p>No data available</p>
    </div>
  }

  <!-- Paginator -->
  @if (config().total > 0) {
    <mat-paginator
      [length]="config().total"
      [pageSize]="pageSize()"
      [pageIndex]="pageIndex()"
      [pageSizeOptions]="config().pageSizeOptions || [5, 10, 25]"
      [showFirstLastButtons]="config().showFirstLastButtons !== false"
      (page)="onPageChange($event)"
    >
    </mat-paginator>
  }
</div>
